import moment from 'moment';

const getIsAnonymous = (value) => value === 'Anonymous' || value === '' || value === null;

const ValueUnlessAnonymous = ({ value }) => (
  <span className={getIsAnonymous(value) ? 'text-gray-700' : ''}>{getIsAnonymous(value) ? 'Anonymous' : value}</span>
);

const FounderRoomAnalyticsViewsRow = ({ data }) => data.map((item) => (
  {
    createdAt: moment(item.createdAt).format('MM/DD/YYYY @ hh:mm a'),
    email: item.email,
    orgName: (<ValueUnlessAnonymous value={item.orgName} />),
    lastName: (<ValueUnlessAnonymous value={item.lastName} />),
    firstName: (<ValueUnlessAnonymous value={item.firstName} />),
  }
));

export default FounderRoomAnalyticsViewsRow;
